import styles from "./EditScreenSelector.module.css";

import arrow from "../../assets/images/icons/selector_down_arrow.png";
import { useState } from "react";
const EditScreenSelector = ({
  options,
  callback,
  selected,
  takeupspace = false,
  alignLeft = false,
}) => {
  const handleChange = (event) => {
    console.log(event.target.value);
    callback(event.target.value);
  };
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <>
      {/* <select onChange={handleChange} className={styles.main_div}>
        {options.map((item, index) => {
          return (
            <option
              selected={item === selected}
              className={styles.option_div}
              key={index}
              value={item}
            >
              {item}
            </option>
          );
        })}
      </select> */}
      <div className={styles.selector_main}>
        <div
          style={{
            cursor: openDialog ? "default" : "pointer",
          }}
          className={styles.selector_first_box}
          onClick={() => {
            setOpenDialog(!openDialog);
          }}
        >
          <img
            src={arrow}
            className={styles.selector_first_icon}
            alt="selector"
          />
          {selected}
        </div>
        {openDialog && (
          <div
            className={styles.second_box}
            style={{
              position: takeupspace ? "relative" : "absolute",
              marginTop: takeupspace ? "0px" : "40px",
            }}
          >
            {Array.isArray(options) &&
              options.length > 0 &&
              options.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      console.log(item);
                      setOpenDialog(false);
                      callback(item);
                    }}
                    className={styles.selector_rest_box}
                  >
                    {item}
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};
export default EditScreenSelector;
